// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== GLOBAL RESET & BASE ===== */
/* Note: Google Fonts are loaded from \`public/index.html\` via <link rel="stylesheet"> to avoid CSS @import render blocking. */

/*
  Primary font: Bahnschrift (Windows system font)
  - "Bahnschrift" is available on Windows 10+ as a system variable font.
  - If a visitor's OS doesn't include Bahnschrift, the stack falls back to Inter and system UI fonts.
  - To guarantee Bahnschrift across all platforms you'd need to self-host the font files or provide a webfont (not bundled here).
*/

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Performance optimization: Minimal GPU acceleration */
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  /* Professional corporate font: DM Sans for modern, sophisticated appearance */
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
  color: #1e293b;
  line-height: 1.6;
  background: #ffffff;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Hide native scrollbars visually but keep scrolling functional */
/* Firefox */
html, body, .site-main, .container {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

/* WebKit (Chrome, Safari, Edge) */
html::-webkit-scrollbar, body::-webkit-scrollbar, .site-main::-webkit-scrollbar, .container::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/* Keep focus outlines for accessibility even when scrollbars hidden */
:focus {
  outline: 2px solid #000000;
  outline-offset: 2px;
}

/* Spinner animation for lazy loading */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.site-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #FFF;
}

/* ===== HEADER ===== */
.site-header {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  max-width: 100%;
  margin: 0 auto;
}

/* Reset button click/focus styles: remove elevation and orange border on mouse click,
  but keep an accessible ring for keyboard users via :focus-visible */
button,
input[type="button"],
input[type="submit"],
input[type="reset"],
a[role="button"],
.btn {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  transform: none !important;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  border-color: transparent;
}

/* Remove outline/box-shadow for mouse clicks (when element is focused but not focus-visible) */
button:focus:not(:focus-visible),
input[type="button"]:focus:not(:focus-visible),
input[type="submit"]:focus:not(:focus-visible),
input[type="reset"]:focus:not(:focus-visible),
a[role="button"]:focus:not(:focus-visible),
.btn:focus:not(:focus-visible) {
  outline: none !important;
  box-shadow: none !important;
  border-color: transparent !important;
}

/* Remove elevation/active shadow on press */
button:active,
input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active,
a[role="button"]:active,
.btn:active {
  box-shadow: none !important;
  transform: none !important;
}

/* Preserve keyboard accessibility: show focus ring only for keyboard users */
button:focus-visible,
input[type="button"]:focus-visible,
input[type="submit"]:focus-visible,
input[type="reset"]:focus-visible,
a[role="button"]:focus-visible,
.btn:focus-visible {
  outline: 2px solid #ff6b35;
  outline-offset: 2px;
}


.main-nav {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.main-nav a {
  color: #cbd5e1;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.3s ease, transform 0.2s ease;
  position: relative;
}

.main-nav a:hover {
  color: #ffffff;
  transform: translateY(-2px);
}

.main-nav a::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: #ff6b35;
  transition: width 0.3s ease;
}

.main-nav a:hover::after {
  width: 100%;
}

/* ===== MAIN CONTENT ===== */
.site-main {
  flex: 1 1;
  width: 100%;
  background: transparent;
}

.container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

.full-width {
  width: 100%;
  padding: 0;
}



/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .header-inner {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .main-nav {
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
  }

  .container {
    padding: 0 1rem;
  }
}

/* Global Typography Overrides */
h1, h2, h3, h4, h5, h6, .brand-text, .brand-name {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC,6HAA6H;;AAE7H;;;;;CAKC;;AAED;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,8EAA8E;EAC9E,4FAA4F;EAC5F,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,kEAAkE;AAClE,YAAY;AACZ;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,WAAW;AACvC;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;qEACqE;AACrE;;;;;;EAME,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,yBAAyB;AAC3B;;AAEA,+FAA+F;AAC/F;;;;;;EAME,wBAAwB;EACxB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA,4CAA4C;AAC5C;;;;;;EAME,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,6EAA6E;AAC7E;;;;;;EAME,0BAA0B;EAC1B,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;;;AAIA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,4FAA4F;EAC5F,gBAAgB;AAClB","sourcesContent":["/* ===== GLOBAL RESET & BASE ===== */\n/* Note: Google Fonts are loaded from `public/index.html` via <link rel=\"stylesheet\"> to avoid CSS @import render blocking. */\n\n/*\n  Primary font: Bahnschrift (Windows system font)\n  - \"Bahnschrift\" is available on Windows 10+ as a system variable font.\n  - If a visitor's OS doesn't include Bahnschrift, the stack falls back to Inter and system UI fonts.\n  - To guarantee Bahnschrift across all platforms you'd need to self-host the font files or provide a webfont (not bundled here).\n*/\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Performance optimization: Minimal GPU acceleration */\nhtml {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  /* Professional corporate font: DM Sans for modern, sophisticated appearance */\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;\n  color: #1e293b;\n  line-height: 1.6;\n  background: #ffffff;\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Hide native scrollbars visually but keep scrolling functional */\n/* Firefox */\nhtml, body, .site-main, .container {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE 10+ */\n}\n\n/* WebKit (Chrome, Safari, Edge) */\nhtml::-webkit-scrollbar, body::-webkit-scrollbar, .site-main::-webkit-scrollbar, .container::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n\n/* Keep focus outlines for accessibility even when scrollbars hidden */\n:focus {\n  outline: 2px solid #000000;\n  outline-offset: 2px;\n}\n\n/* Spinner animation for lazy loading */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.site-root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #FFF;\n}\n\n/* ===== HEADER ===== */\n.site-header {\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 2rem;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n/* Reset button click/focus styles: remove elevation and orange border on mouse click,\n  but keep an accessible ring for keyboard users via :focus-visible */\nbutton,\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"],\na[role=\"button\"],\n.btn {\n  box-shadow: none !important;\n  -webkit-box-shadow: none !important;\n  transform: none !important;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n  border-color: transparent;\n}\n\n/* Remove outline/box-shadow for mouse clicks (when element is focused but not focus-visible) */\nbutton:focus:not(:focus-visible),\ninput[type=\"button\"]:focus:not(:focus-visible),\ninput[type=\"submit\"]:focus:not(:focus-visible),\ninput[type=\"reset\"]:focus:not(:focus-visible),\na[role=\"button\"]:focus:not(:focus-visible),\n.btn:focus:not(:focus-visible) {\n  outline: none !important;\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n\n/* Remove elevation/active shadow on press */\nbutton:active,\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active,\na[role=\"button\"]:active,\n.btn:active {\n  box-shadow: none !important;\n  transform: none !important;\n}\n\n/* Preserve keyboard accessibility: show focus ring only for keyboard users */\nbutton:focus-visible,\ninput[type=\"button\"]:focus-visible,\ninput[type=\"submit\"]:focus-visible,\ninput[type=\"reset\"]:focus-visible,\na[role=\"button\"]:focus-visible,\n.btn:focus-visible {\n  outline: 2px solid #ff6b35;\n  outline-offset: 2px;\n}\n\n\n.main-nav {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\n\n.main-nav a {\n  color: #cbd5e1;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1rem;\n  transition: color 0.3s ease, transform 0.2s ease;\n  position: relative;\n}\n\n.main-nav a:hover {\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n.main-nav a::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: #ff6b35;\n  transition: width 0.3s ease;\n}\n\n.main-nav a:hover::after {\n  width: 100%;\n}\n\n/* ===== MAIN CONTENT ===== */\n.site-main {\n  flex: 1;\n  width: 100%;\n  background: transparent;\n}\n\n.container {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.full-width {\n  width: 100%;\n  padding: 0;\n}\n\n\n\n/* ===== RESPONSIVE ===== */\n@media (max-width: 768px) {\n  .header-inner {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .main-nav {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 1rem;\n  }\n\n  .container {\n    padding: 0 1rem;\n  }\n}\n\n/* Global Typography Overrides */\nh1, h2, h3, h4, h5, h6, .brand-text, .brand-name {\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
